import React from 'react'

const ChevronRight = ({ width = '20px', height = '20px', ...rest }) => (
  <svg viewBox="0 0 20 20" width={width} height={height} {...rest}>
    <path d="M8.2 4.3L6.8 5.7l4.3 4.3-4.3 4.3 1.4 1.4 5.7-5.7z" />
  </svg>
)

export default ChevronRight
